module.exports = __webpack_public_path__ + "pic/72.7ee82f12.png";